import _ from 'underscore'
import { deepDefaults } from '@polleverywhere/core/lib/util.js'
import ActivityCollection from '@polleverywhere/core/lib/models/activity_collection'
import { preloadPlaceholders } from './multiple_image_helpers.js'
import { createSlideSet } from './slideset.js'

const MAX_POLLS = 1000

export const updatePlaceholders = async (user) => {
  if (!user.isLoggedIn()) {
    console.error('updatePlaceholders: user is not logged in.')
  }

  const opts = {
    data: {
      user_id: user.get('id'),
      per_page: MAX_POLLS
    }
  }

  const fetches = []
  // Store the user's polls
  fetches.push(user.polls.fetch(opts))
  // web_presenter port: Try to get the user's competitions (I guess that's different from polls?)
  const competitions = new ActivityCollection()
  const competitionsFetch = competitions.fetch(deepDefaults({ data: { type: 'competition' } }, opts))
  // web_presenter port: Do we need store the top of the fetch if we are executing it, and storing the sub fetches?
  fetches.push(competitionsFetch)
  // Store the individual competition slides
  competitionsFetch.then(() => {
    fetches.push(...competitions.map(competition => competition.fetch()))
  })

  await Promise.all(fetches).catch(err => console.error('Fetch activities error', err))

  // web_presenter port: Why would there be a competition poll in the user's polls if they have to be gotten from a collection?
  const nonCompetitionPolls = user.polls.reject(poll => poll.has('competition_instance'))

  // Get the slide set data for user polls
  const activitySlideSet = await createSlideSet(nonCompetitionPolls.concat(competitions.models))
  const activityPlaceholderUrls = _.uniq(activitySlideSet.getData().map(data => data.placeholderUrl))

  if (activityPlaceholderUrls.length) {
    preloadPlaceholders(activityPlaceholderUrls)
  }
}
